module.exports = __webpack_public_path__ + "img/logo.d5f20c53.png";